export const normalizeAnalyticsKey = (value: string) =>
  value.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
